export const productShortName = 'Fire Protection & Suppression Systems — Professional Edition';
export const productBrand = 'Fire Protection & Suppression Systems';
export const productEdition = 'Professional Edition';
export const productLabel = 'Fire Protection & Suppression Systems · Professional Edition';
export const productImage = 'https://cdn.magicpatterns.com/uploads/14UsvwLTAtaN91oWUUTwaK/MOCKUP_FIRE.png';
export const productImageAlt =
  'Fire Protection & Suppression Systems Professional Edition: six volumes covering fire science and strategy, detection and alarm, sprinkler systems, water supply and fire pumps, foam, clean agents and CO2, and inspection, testing and maintenance, plus five bonus resources';

export const checkoutUrl = 'https://fire-protection-suppression-systems.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = 'USD 14.00';
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about how detection, sprinklers, pumps and special-hazard systems fit together',
  'No more uncertainty when a panel goes into fault or a system needs service',
  'No more gaps in understanding water supplies, fire pumps, hydrants and standpipes',
  'No more guessing how foam, clean agents, CO2 and water mist really work',
  'No more improvising inspection, testing and maintenance routines',
];
